import { LicenseManager } from 'ag-grid-enterprise';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { DecoratorServiceProvider } from '@core/utils/decorator-service-provider';
import { environment } from '@env/environment';
import { AppModule } from './app/app.module';
import clarity from '@microsoft/clarity';
import { v4 as uuidv4 } from 'uuid';

LicenseManager.setLicenseKey(environment.agGridEnterpriseKey);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  // DecoratorServiceProvider is injected here to generate the instance.
  // Internally it is saving a static variable that helps the @Provide directive to work.
  .then(moduleRef => DecoratorServiceProvider.setInjector(moduleRef.injector))
  .catch(err => console.error('Bootstrap failed:', err?.message ?? err));

const initializeClarity = () => {
  const projectId = environment.clarity.projectId;
  if (projectId) {
    clarity.init(projectId);
    const userInfo = localStorage.getItem('userInfo');
    if (userInfo) {
      try {
        const { id, emailAddress } = JSON.parse(userInfo);
        // Ensure all parameters are strings for Clarity
        clarity.identify(String(id || ''), uuidv4(), 'marketiq-page-id', String(emailAddress || ''));
      } catch {
        console.warn('Failed to identify user in Clarity');
      }
    }
  } else {
    console.warn('MS Clarity Project Id is undefined. Skipping clarity initialization.');
  }
};
initializeClarity();
